import { useQuery } from '@tanstack/react-query';
import { PropBotGrowthService, PropBotGrowthData } from '@/services/prop-bot/prop-bot-growth-service';

export const usePropBotGrowth = (
  botId: string,
  fallbackWinPercentage?: number,
  fallbackLossPercentage?: number,
  fallbackMinCapital?: number
) => {
  return useQuery<PropBotGrowthData>({
    queryKey: ['propBotGrowth', botId],
    queryFn: () => PropBotGrowthService.getPropBotGrowthData(
      botId,
      fallbackWinPercentage,
      fallbackLossPercentage,
      fallbackMinCapital
    ),
    enabled: !!botId,
    staleTime: 5 * 60 * 1000, // 5 minutes - avoid unnecessary refetches
    gcTime: 10 * 60 * 1000, // 10 minutes - keep data stable (gcTime replaces cacheTime in v5)
    retry: (failureCount, error) => {
      // Don't retry on permission errors
      if (error?.message?.includes('permission') || error?.message?.includes('RLS')) {
        return false;
      }
      return failureCount < 2;
    },
  });
};